module.exports = __webpack_public_path__ + "img/reference63.4c677c1b.jpg";